"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SortArrow_1 = __importDefault(require("./SortArrow/SortArrow"));
const Header_styles_1 = require("./Header.styles");
const constants_1 = require("./constants");
/** Component that renders the header label.
 * If the header is sorted, styling will be applied including
 * boldened text and an arrow indicating the direction of the sort.
 */
const HeaderLabel = ({ headerLabel, sortOrder }) => {
    const renderSortedStyledHeaderLabel = (react_1.default.createElement(Header_styles_1.StyledHeaderLabel, null,
        headerLabel,
        react_1.default.createElement(SortArrow_1.default, { sortOrder: sortOrder })));
    const renderRegularHeaderLabel = react_1.default.createElement("span", null, headerLabel);
    return sortOrder !== constants_1.SortOrder.NONE
        ? renderSortedStyledHeaderLabel
        : renderRegularHeaderLabel;
};
exports.default = HeaderLabel;
//# sourceMappingURL=HeaderLabel.js.map